import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CaretDown, SignOut, UserCircle, Heart } from '@phosphor-icons/react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const getDashboardPath = () => {
    if (user?.role === 'patient') return '/patient';
    if (user?.role === 'doctor') return '/doctor';
    if (user?.role === 'admin') return '/admin';
    return '/';
  };

  return (
    <nav className="glass-header fixed top-0 left-0 right-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 font-spectral text-xl font-semibold text-primary"
            data-testid="navbar-logo"
          >
            <Heart size={28} weight="duotone" className="text-primary" />
            SecondDoctorOpinion
          </Link>

          <div className="flex items-center gap-6">
            {user ? (
              <>
                <Link
                  to={getDashboardPath()}
                  className="text-sm font-medium text-secondary hover:text-primary transition-colors"
                  data-testid="navbar-dashboard-link"
                >
                  Dashboard
                </Link>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button
                      className="flex items-center gap-2 text-sm font-medium text-secondary hover:text-primary transition-colors"
                      data-testid="navbar-user-menu"
                    >
                      <UserCircle size={24} weight="duotone" />
                      <span>{user.name}</span>
                      <CaretDown size={16} />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-48">
                    <DropdownMenuItem
                      onClick={logout}
                      className="cursor-pointer"
                      data-testid="navbar-logout-button"
                    >
                      <SignOut size={16} className="mr-2" />
                      Logout
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            ) : (
              <>
                <Link
                  to="/blog"
                  className="text-sm font-medium text-secondary hover:text-primary transition-colors hidden md:inline"
                  data-testid="navbar-blog-link"
                >
                  Blog
                </Link>
                <Link
                  to="/doctors/apply"
                  className="text-sm font-medium text-secondary hover:text-primary transition-colors hidden sm:inline"
                  data-testid="navbar-for-doctors-link"
                >
                  For Doctors
                </Link>
                <Link
                  to="/login"
                  className="text-sm font-medium text-secondary hover:text-primary transition-colors"
                  data-testid="navbar-login-link"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="btn-primary text-sm px-6 py-2"
                  data-testid="navbar-register-link"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}